import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Backdrop,
  Box,
  Button,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { CustomButton } from "../CustomButton/CustomButton";
import error from "../../assets/delete.gif";

// Slide transition animation

const CustomDialog = ({
  open,
  titleLeft,
  onClose,
  title = "Success",
  description = "Operation completed successfully.",
  primaryButtonText = "OK",
  secondaryButtonText = "Cancel",
  onPrimaryClick,
  onSecondaryClick,
  type,
}) => {
  return (
    <Dialog
      open={open}
      keepMounted
      onClose={onClose}
      aria-labelledby="custom-dialog-title"
      aria-describedby="custom-dialog-description"
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500, // Smooth fade-in backdrop
      }}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "20px", // Curved edges
          padding: "20px",
          minWidth: "350px",
          textAlign: titleLeft ? "left" : "center",
        },
      }}
    >
      {/* Title & Icon */}
      <DialogTitle id="custom-dialog-title">
        <Box
          display="flex"
          flexDirection="column"
          alignItems={titleLeft ? "left" : "center"}
          gap={1}
        >
          {type && (
            <>
              {type === "success" ? (
                <CheckCircleIcon sx={{ color: "green", fontSize: 50 }} />
              ) : (
                <img src={error} alt="error" style={{ width: "80px" }} />
              )}
            </>
          )}

          <Typography variant="h5">{title}</Typography>
        </Box>
      </DialogTitle>

      {/* Description */}
      <DialogContent>
        <h3 style={{ fontWeight: "500" }}>{description}</h3>
      </DialogContent>

      {/* Buttons */}
      <DialogActions sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
        <Button
          onClick={onSecondaryClick || onClose}
          color="error"
          variant="outlined"
          sx={{ minWidth: "150px", textTransform: "unset" }}
        >
          {secondaryButtonText}
        </Button>
        <CustomButton
          onClick={onPrimaryClick}
          variant="contained"
          color="primary"
          sx={{ minWidth: "150px", textTransform: "unset" }}
        >
          {primaryButtonText}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;
